import type { ToolUseRenderBlock } from "@/lib/chat-render";

/**
 * run 行が作られないまま終わった run_subagent (起動拒否・入力検証エラー・HITL 混在拒否)。
 * 理由は tool_result にしか無いため、run を前提に描くサブエージェントカードでは読めない。
 */
function isRejectedSubagentLaunch(tool: ToolUseRenderBlock): boolean {
	return tool.subagentRun === undefined && (tool.status === "error" || tool.status === "skipped");
}

/**
 * 投入されなかった run_workflow (承認待ち・投入拒否・入力検証エラー)。理由と入力は tool_result と
 * input にしか無いため、workflow 行を前提に描くカードでは読めない。
 */
function isUnlaunchedWorkflow(tool: ToolUseRenderBlock): boolean {
	return tool.workflowRun === undefined && tool.status !== "running";
}

/** ツール 1 件をどのカードで描くか。 */
export function toolCardKind(
	tool: ToolUseRenderBlock,
): "hitl" | "subagent" | "workflow" | "generic" {
	if (tool.name === "request_user_choice") return "hitl";
	if (tool.name === "run_subagent" && !isRejectedSubagentLaunch(tool)) return "subagent";
	if (tool.name === "run_workflow" && !isUnlaunchedWorkflow(tool)) return "workflow";
	return "generic";
}
